import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import CaseSpecimen2dProstate from '../specimen/CaseSpecimen2dProstate';
import '../../style/index.css';


const customContentStyle = {
  border: '1px solid #d3d3d3',
};

export default class Modal2dProstate extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => { this.setState({ open: true }); };

  handleClose = () => { this.setState({ open: false }); };

  render() {
    const {
      specimenLocation,
      coords,
      selected,
      handlePlot,
      editable,
    } = this.props;
    const { open } = this.state;

    if (specimenLocation !== '') {
      const hasPlotLocation = coords.x > 0 || coords.y > 0;
      const imgClassNames = `btn--prostate ${hasPlotLocation ? 'has-plot-location' : ''}`;

      return (
        <div>
          <button
            type="button"
            onClick={this.handleOpen}
            className={imgClassNames}
            alt="plot specimen location"
          />
          <Dialog
            open={open}
            className="modal modal--information"
            onBackdropClick={this.handleClose}
          >
            <h2 style={{textAlign: 'center'}}>Click on exact location</h2>
            <div className="modal-content">
              <CaseSpecimen2dProstate
                specimenLocation={specimenLocation}
                selected={selected}
                coords={coords}
                handlePlot={handlePlot}
                editable={editable}
              />
              <button
                type="button"
                onClick={this.handleClose}
                className="btn--form btn--close-plot-location"
              >
                Save
              </button>
            </div>
          </Dialog>
        </div>
      );
    }
    return <div style={{ height: '34px', marginTop: '-10px', marginBottom: '10px' }} />;
  }
}
